import React, { Component } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';

class DetailedOrderReport extends Component {

  renderOrder(orders) {
    return orders.map( (order, index) => {
      return (
        <tr className="bg-white" key={order.order_id}>
          <td>{order.order_id}</td>
          <td>{order.order_time}</td>
          <td>{order.customer_name}</td>
          <td>{order.server_name}</td>
          <td>{order.pay_location}</td>
          <td>${order.order_total}</td>
          <td>${order.tip_total}</td>
        </tr>
      );
    });
  }

  render() {
    if (this.props.report_day_from === '') {
      return (
        <div></div>
      );
    }

    //console.log(this.props.reports.items);

    if (_.isEmpty(this.props.reports.items) && (this.props.reports.items !== undefined)) {
      return <div>There is no data for this time period.</div>
    } else if (_.isEmpty(this.props.reports.items) === false ) {

      return(
        <div>
          <table className="table mb-0 table-bordered">
            <thead className="thead-inverse">
              <tr>
                <th colSpan="7">Created on: {this.props.report_created} <br /> Detailed Order Report for {this.props.report_day_from} to {this.props.report_day_to}</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <th><b>UNPAID</b></th>
                <th>&nbsp;</th>
              </tr>
              <tr className="bg-white">
                <td><b>Order ID</b></td>
                <td><b>Order Time</b></td>
                <td><b>Customer</b></td>
                <td><b>Server</b></td>
                <td><b>Location</b></td>
                <td><b>Total</b></td>
                <td><b>Tip</b></td>
              </tr>
              {this.renderOrder(this.props.reports.items.unpaid.orders)}
              <tr className="bg-white"><td><b>{this.props.reports.items.unpaid.num_orders} UNPAID Orders</b></td><td colSpan="4">&nbsp;</td><td><b>${this.props.reports.items.unpaid.grand_total}</b></td><td><b>${this.props.reports.items.unpaid.grand_tip_total}</b></td></tr>
              <tr>
                <th><b>CASH</b></th>
                <th>&nbsp;</th>
              </tr>
              <tr className="bg-white">
                <td><b>Order ID</b></td>
                <td><b>Order Time</b></td>
                <td><b>Customer</b></td>
                <td><b>Server</b></td>
                <td><b>Location</b></td>
                <td><b>Total</b></td>
                <td><b>Tip</b></td>
              </tr>
              {this.renderOrder(this.props.reports.items.cash.orders)}
              <tr className="bg-white"><td><b>{this.props.reports.items.cash.num_orders} CASH Orders</b></td><td colSpan="4">&nbsp;</td><td><b>${this.props.reports.items.cash.grand_total}</b></td><td><b>${this.props.reports.items.cash.grand_tip_total}</b></td></tr>
              <tr>
                <th><b>DEBIT</b></th>
                <th>&nbsp;</th>
              </tr>
              <tr className="bg-white">
                <td><b>Order ID</b></td>
                <td><b>Order Time</b></td>
                <td><b>Customer</b></td>
                <td><b>Server</b></td>
                <td><b>Location</b></td>
                <td><b>Total</b></td>
                <td><b>Tip</b></td>
              </tr>
              {this.renderOrder(this.props.reports.items.debit.orders)}
              <tr className="bg-white"><td><b>{this.props.reports.items.debit.num_orders} DEBIT Orders</b></td><td colSpan="4">&nbsp;</td><td><b>${this.props.reports.items.debit.grand_total}</b></td><td><b>${this.props.reports.items.debit.grand_tip_total}</b></td></tr>
              <tr>
                <th><b>VISA</b></th>
                <th>&nbsp;</th>
              </tr>
              <tr className="bg-white">
                <td><b>Order ID</b></td>
                <td><b>Order Time</b></td>
                <td><b>Customer</b></td>
                <td><b>Server</b></td>
                <td><b>Location</b></td>
                <td><b>Total</b></td>
                <td><b>Tip</b></td>
              </tr>
              {this.renderOrder(this.props.reports.items.visa.orders)}
              <tr className="bg-white"><td><b>{this.props.reports.items.visa.num_orders} VISA Orders</b></td><td colSpan="4">&nbsp;</td><td><b>${this.props.reports.items.visa.grand_total}</b></td><td><b>${this.props.reports.items.visa.grand_tip_total}</b></td></tr>
              <tr>
                <th><b>MASTERCARD</b></th>
                <th>&nbsp;</th>
              </tr>
              <tr className="bg-white">
                <td><b>Order ID</b></td>
                <td><b>Order Time</b></td>
                <td><b>Customer</b></td>
                <td><b>Server</b></td>
                <td><b>Location</b></td>
                <td><b>Total</b></td>
                <td><b>Tip</b></td>
              </tr>
              {this.renderOrder(this.props.reports.items.mastercard.orders)}
              <tr className="bg-white"><td><b>{this.props.reports.items.mastercard.num_orders} MASTERCARD Orders</b></td><td colSpan="4">&nbsp;</td><td><b>${this.props.reports.items.mastercard.grand_total}</b></td><td><b>${this.props.reports.items.mastercard.grand_tip_total}</b></td></tr>
              <tr>
                <th><b>AMEX</b></th>
                <th>&nbsp;</th>
              </tr>
              <tr className="bg-white">
                <td><b>Order ID</b></td>
                <td><b>Order Time</b></td>
                <td><b>Customer</b></td>
                <td><b>Server</b></td>
                <td><b>Location</b></td>
                <td><b>Total</b></td>
                <td><b>Tip</b></td>
              </tr>
              {this.renderOrder(this.props.reports.items.amex.orders)}
              <tr className="bg-white"><td><b>{this.props.reports.items.amex.num_orders} AMEX Orders</b></td><td colSpan="4">&nbsp;</td><td><b>${this.props.reports.items.amex.grand_total}</b></td><td><b>${this.props.reports.items.amex.grand_tip_total}</b></td></tr>
              <tr className="bg-white"><td><b>{this.props.reports.items.grand_num_orders} Grand Total Orders</b></td><td className="right-text" colSpan="4"><b>Grand Total</b></td><td><b>${this.props.reports.items.grand_total}</b></td><td><b>${this.props.reports.items.grand_tip_total}</b></td></tr>
            </tbody>
          </table>
        </div>
      );
    }
  }
}

function mapStateToProps({ reports }) {
  return { reports };
}

export default connect(mapStateToProps, null)(DetailedOrderReport);



// WEBPACK FOOTER //
// ./src/containers/detailed_order_report.js